import React, { useState } from "react";

import { usePhysicalEdition } from "../hooks";
import { physicalEditionSeo } from "../config";
import { mapPhysicalEditionToCardProps } from "../services";
import { CollectionIntro } from "../components";
import { ProductGrid } from "../../../shared/index.js";
import {
  physicalEditionListConfig,
  resolveListMaxItems,
} from "../../../core/configurations";

/**
 * Physical Edition page.
 */

const PhysicalEdition = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const { data } = usePhysicalEdition();

  const {
    title,
    subtitle,
    description,
    tags,
    ctaLabel,
    coverImage,
    article,
    products,
  } = data;

  const handleBuy = (item) => window.open(item.link, "_blank");
  return (
    <div className="PhysicalEdition">
      <CollectionIntro
        seo={physicalEditionSeo}
        cover={{
          title,
          subtitle,
          description,
          ctaLabel,
          image: coverImage,
          tags,
        }}
        article={article}
        searchPlaceholder="Search posters"
      />
      <ProductGrid
        items={products}
        maxItems={resolveListMaxItems(physicalEditionListConfig)}
        getCardProps={mapPhysicalEditionToCardProps}
        getKey={(item) => item.id}
        onItemClick={setSelectedItem}
        onItemPurchase={handleBuy}
      />
    </div>
  );
};

export default PhysicalEdition;
